import React, { Fragment, useEffect } from 'react';
import { Container, Row, Card, CardBody, Col } from 'reactstrap';
import { Breadcrumbs, UL, LI, P, H6 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { getTimeDiff } from '../../../../Library/custom_utils';
import { getCustomerNotificationsAPI } from '../../../../Library/apis';
import { useState } from 'react';
import MothriftLoader from '../../Common/MothriftLoader';

const renderItem = (item, i) => {
  let status = 'success';
  if (item.event.includes('Canceled')) status = 'secondary'
  else if (item.event.includes('Started')) status = 'primary'
  else if (item.event.includes('Deposited Fund')) status = 'info'
  else if (item.event.includes('Payment Verification')) status = 'warning'
  else if (item.title == '') status = 'primary'

  return (
    <UL attrUL={{ style: { marginLeft: '10px' } }}>
      <LI key={i} attrLI={{ className: 'd-flex' }}>
        <div className={`activity-dot-${status}`} />
        <div className='w-100 ms-3'>
          <P attrPara={{ className: 'd-flex justify-content-between mb-1' }}>
            <span className={`date-content light-background font-${status}`}>{getTimeDiff(item.createdAt)}</span>
          </P>
          <H6 attrH6={{ className: `mb-2` }}>
            {item.event}
            <span className='dot-notification' />
          </H6>
          <div className='d-flex align-items-center' >
            <P attrPara={{ className: `mb-0 me-2` }}>{item.userId}</P>
            <span className='f-light'>{item.title}</span>
          </div>
        </div>
      </LI>
    </UL>
  )
}

const customStyles = {
  header: {
    style: {
      borderBottom: '0px !important'
    },
  },
  rows: {
    style: {
      borderBottom: '0px !important'
    },
  },
};

const CustomerNotifications = () => {
  const [customerNotifications, setCustomerNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getCustomerNotificationsAPI().then(res => {
      setIsLoading(false);
      setCustomerNotifications(res.body);
    }).catch(() => {
      setIsLoading(false);
    })
  }, [])

  const notificationTableData = () => {
    return customerNotifications.map((item, i) => {
      return {
        id: i,
        item: renderItem(item, i)
      }
    })
  }

  return (
    <Fragment>
      <Breadcrumbs mainTitle='Customer Notifications' parent='Mothrift' title='Customer Notifications' />
      <Container fluid={true}>
        <Row className='size-column'>
          <Col xxl='12' xl='12' md='12'>
            <Card>
              <CardBody className='card-body pt-0'>
                <div>
                  <div className='recent-activity notification mt-3'>
                    {isLoading ? <MothriftLoader /> :
                      <DataTable
                        data={notificationTableData()}
                        columns={[{ name: 'Item', selector: row => row['item'] }]}
                        center={true}
                        pagination
                        noTableHead
                        dense
                        paginationPerPage={20}
                        customStyles={customStyles}
                      />}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CustomerNotifications;
